import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot instead of ReactDOM
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// Get the root DOM element
const rootElement = document.getElementById('root');
// Create a root using createRoot
const root = createRoot(rootElement);
// Render the app into the root
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);